import { useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { type RootState } from 'app/store'
import { setTourId } from 'app/store/slices/editableTournament'
import { mapDispatchToProps } from 'pages/TournamentsPage/maps'
import { takeBinaryDivideNumber } from 'shared/tournaments/procedures'
import styles from "./tournament-grid.module.css"
import { PlayersList } from 'widgets/tournament/players-list/players-list'
import { TournamentDoubleTourCardsList } from 'widgets/tournament/tournament-double-tour-cards-list'
import { useOnChangeParamsAction } from 'widgets/tournament/tournament-grid-editor/hooks/useOnChangeParamsAction'
import { TournamentGridParams } from 'widgets/tournament/tournament-grid-params/tournament-grid-params'
import { TournamentGridToursTabs } from 'widgets/tournament/tournament-grid-tours-tabs'
import { TournamentTourCardsList } from 'widgets/tournament/tournament-tour-cards-list'

const mapStateToProps = (state: RootState) => ({
  manualGridEdition: state.editableTournamentSlice.manualGridEdition,
  internalPlayers: state.editableTournamentSlice.internalPlayers,
  isEllimination: state.editableTournamentSlice.isEllimination,
  activePlayers: state.editableTournamentSlice.activePlayers,
  gridFirstSize: state.editableTournamentSlice.gridFirstSize,
  gridLastSize: state.editableTournamentSlice.gridLastSize,
  tours: state.editableTournamentSlice.tours,
  tourId: state.editableTournamentSlice.selectableParameters.tourId,
  type: state.editableTournamentSlice.type
})

export const TournamentGrid = connect(mapStateToProps, mapDispatchToProps)(function ({
  activePlayers,
  internalPlayers,
  gridFirstSize,
  gridLastSize,
  isEllimination,
  tours,
  tourId,
  type
}: any) {
  const dispatch = useDispatch()

  useEffect(() => {

    if(!tours){
      return
    }

    if(tours.length === 0){
      return
    }

    if( tourId >= tours.length && isEllimination ){
        dispatch(setTourId(0))
    }  
  }, [tourId, tours])

  const permissibleFirstQuantity = (gridFirstSize * 2)
  
  const toursNumberEstimation = takeBinaryDivideNumber(gridFirstSize) - takeBinaryDivideNumber(gridLastSize)

  useOnChangeParamsAction()

  const players = useMemo(() => [...internalPlayers, ...activePlayers], [internalPlayers, activePlayers])

  if(players.length === 0){
    return <div style={{
      marginTop: 30
    }}>В системе нет ни одного игрока. Добавьте игроков в предыдущем меню что бы сетка стала активной</div>
  }

  return <div className={styles.TournamentGrid}>
    <TournamentGridToursTabs
      toursNumberEstimation={toursNumberEstimation}
      permissibleFirstQuantity={permissibleFirstQuantity}
    />
    {isEllimination && <TournamentGridParams />}
    <div className={styles.EditorFrame}>
      {type && type === "single" && <TournamentTourCardsList/>}
      {type && type === "double" && <TournamentDoubleTourCardsList/>}
      {/* <div className={styles.PlayersListContainer}>
        <PlayersList />
      </div> */}
    </div>
  </div>
})
